import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  GPDS_FILTER_REQUEST,
  GPDS_FILTER_SUCCESS,
  GPDS_FILTER_FAILURE,
  GPDS_FILTER_CLEAR,
  GPDS_FILTER_DELETE,
  GPDS_FILTER_SET,
  GPDS_FILTER_UPDATE,
} from 'app/actions/reports/filters/gpds';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const gpds = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GPDS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case GPDS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case GPDS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case GPDS_FILTER_CLEAR: {
      return defaultState;
    }
    case GPDS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case GPDS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case GPDS_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default gpds;
